import { useEffect, useState } from "react";
import { ExternalStockApiType, fetchExternalStock } from "../api/ApiService";

export const useExternalStock = ({ sku, permanentDomain, country, ownStock }: { sku: string; permanentDomain: string; country: string; ownStock: number }) => {
  const [textColor, setTextColor] = useState<string | null>(null);
  const [message, setMessage] = useState<string[]>([]);

  useEffect(() => {
    const fetch = async () => {
      const externalStock: ExternalStockApiType = await fetchExternalStock(sku, permanentDomain, country);

      let text = [];
      if (ownStock > 0) {
        text.push(`${ownStock} ${ownStock === 1 ? "pc" : "pcs"} available in our shop (1-2 days lead time)`);
      }

      if (externalStock?.stock > 0) {
        text.push(`${externalStock.stock} ${externalStock.stock === 1 ? "pc" : "pcs"} available in the warehouse (5-7 days lead time)`);
      }

      setMessage(text);
      setTextColor(externalStock.textColor);
    };

    fetch();
  }, [sku, permanentDomain, country, ownStock]);

  return { textColor, message };
};
